angular.module('impactx.rfx').controller('RfxRequestSupportDetailsCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    '$mdToast',
    '$context',
    '$securityManager',
    'RFXSupplierService',
    'ToastService',
    'rfqhId',
    RfxRequestSupportDetailsCtrl
]);

function RfxRequestSupportDetailsCtrl($scope, dataGen, $mdDialog, TranslationService, $mdToast,
                               $context, $securityManager, RFXSupplierService, ToastService, rfqhId) {

        var ctrl = this;

        ctrl.getData = function () {
            var paramObj = {
                rfqhId: rfqhId
            };
            dataGen.getData($scope, paramObj, '/rfx/buyer/requestsupportdetails').then(function () {
                if ($scope.trns) {
                    $scope.trns.save = TranslationService.get('save');
                    $scope.trns.cancel = TranslationService.get('abort');
                }
            });
        };

        ctrl.save = function () {
            var paramObj = {
                data: $scope.data
            };
            dataGen.postAsForm({}, paramObj, '/rfx/buyer/requestsupport').then(function () {
                $mdDialog.hide();
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            });
        };

        ctrl.cancel = function () {
            $mdDialog.cancel();
        };

        ctrl.getData();
    }